import React from "react";
import { Link } from "react-router-dom";
import { versionTrack } from "./track.dto"; 

function Track3Card() {
  return (
    <div>
      <div className=" m-3 rounded p-3 track">
          <h4 className="align-left">Track 3 - <span className="track-name">Version Controlling</span></h4>
          <hr className="hr" />
      {versionTrack.map((track3, index) => (
        <div className="row track-card pt-3 w-70" key={index}>
          <div className="col-4">
            <img
              src={track3.image} 
              className="p-0 img-fluid m-0 rounded-start track-img"
              alt=""
            />
          </div>
          <div className="col-6">
            <h5 className="card-title fw-bold">{track3.title}</h5>
            <p className="card-text fw-light mt-2">{track3.description}</p> 
            <Link
                to={`/track3Detail/${track3.id}`}
                className="btn track-btn align-self-start"
              >
                Detail
              </Link>
          </div>
        </div>
      ))}
    </div>
    </div>

  );
}

export default Track3Card;
